import { render, staticRenderFns } from "./CalibrationStandardDetail.vue?vue&type=template&id=c2c25d1e"
import script from "./CalibrationStandardDetail.vue?vue&type=script&lang=js"
export * from "./CalibrationStandardDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports